/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/*
 *
 * Action types for Connectivity.
 *
 */
import ReduxUtils from '../../utils/ReduxUtils';
var SET_ONLINE = ReduxUtils.generateActionType('ua-library', "CONNECTIVITY", 'SET_ONLINE');
var SET_PREVENT_ACTION_ON_OFFLINE = ReduxUtils.generateActionType('ua-library', "CONNECTIVITY", 'SET_PREVENT_ACTION_ON_OFFLINE');
export { SET_ONLINE, SET_PREVENT_ACTION_ON_OFFLINE };